import { Component, OnInit } from "@angular/core";
import { MenuController } from "@ionic/angular";
import { HeaderModel } from "../../_component/header/header.model";

@Component({
  selector: "app-legal",
  templateUrl: "./legal.page.html",
  styleUrls: ["./legal.page.scss"],
})
export class LegalPage{

  constructor(
    private menu: MenuController,
  ) { }

  headerInit: HeaderModel = {
    title: "COM",
  };
}
